import { RouteObject } from "react-router-dom";
import { lazyWithRetry as lazy } from "./lazyWithRetry";

const HomePage = lazy(() => import("../pages/home/page"));
const ProgrammeOverviewPage = lazy(
  () => import("../pages/programme-overview/page"),
);
const PackagesPage = lazy(() => import("../pages/packages/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const EgyptGuidePage = lazy(() => import("../pages/egypt-guide/page"));
const FAQPage = lazy(() => import("../pages/faq/page"));
const ApplyPage = lazy(() => import("../pages/apply/page"));
const PrivacyPolicyPage = lazy(() => import("../pages/privacy-policy/page"));
const TermsOfServicePage = lazy(() => import("../pages/terms-of-service/page"));
const CookiePolicyPage = lazy(() => import("../pages/cookie-policy/page"));
const DisclaimerPage = lazy(() => import("../pages/disclaimer/page"));
const LaunchOfferTermsPage = lazy(
  () => import("../pages/launch-offer-terms/page"),
);
const OnlineClassesSignupPage = lazy(
  () => import("../pages/online-classes-signup/page"),
);
const OnlinePage = lazy(() => import("../pages/online/page"));
const OnlineProgrammePage = lazy(() => import("../pages/online/programme/page"));
const OnlineTeachersPage = lazy(() => import("../pages/online/teachers/page"));
const OnlinePricingPage = lazy(() => import("../pages/online/pricing/page"));
const OnlineOnboardingPage = lazy(() => import("../pages/online/onboarding/page"));
const OnlineTermsPage = lazy(() => import("../pages/online/terms/page"));
const OnlinePrivacyPage = lazy(() => import("../pages/online/privacy/page"));
const AdminLoginPage = lazy(() => import("../pages/admin/login/page"));
const AdminDashboardPage = lazy(() => import("../pages/admin/page"));
const AdminReferralsPage = lazy(() => import("../pages/admin/referrals/page"));
const AdminReferralAnalyticsPage = lazy(
  () => import("../pages/admin/referrals/analytics/page"),
);
const AdminSettingsPage = lazy(() => import("../pages/admin/settings/page"));
const AdminLedgerEntryPage = lazy(
  () => import("../pages/admin/ledger-entry/page"),
);
const AdminPromotionsPage = lazy(
  () => import("../pages/admin/promotions/page"),
);

const AdminSessionsPage = lazy(() => import("../pages/admin/sessions/page"));
const AdminApplicationPaymentsPage = lazy(
  () => import("../pages/admin/application-payments/page"),
);
const AdminOnlineBillingPage = lazy(() => import("../pages/admin/online-billing/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/programme-overview",
    element: <ProgrammeOverviewPage />,
  },
  {
    path: "/packages",
    element: <PackagesPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/egypt-guide",
    element: <EgyptGuidePage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/apply",
    element: <ApplyPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfServicePage />,
  },
  {
    path: "/cookie-policy",
    element: <CookiePolicyPage />,
  },
  {
    path: "/disclaimer",
    element: <DisclaimerPage />,
  },
  {
    path: "/launch-offer-terms",
    element: <LaunchOfferTermsPage />,
  },
  {
    path: "/online-classes-signup",
    element: <OnlineClassesSignupPage />,
  },
  {
    path: "/online/join",
    element: <OnlineClassesSignupPage />,
  },
  {
    path: "/online/onboarding",
    element: <OnlineOnboardingPage />,
  },
  {
    path: "/online",
    element: <OnlinePage />,
  },
  { path: "/online/programme", element: <OnlineProgrammePage /> },
  { path: "/online/teachers", element: <OnlineTeachersPage /> },
  { path: "/online/pricing", element: <OnlinePricingPage /> },
  { path: "/online/terms", element: <OnlineTermsPage /> },
  { path: "/online/privacy", element: <OnlinePrivacyPage /> },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin",
    element: <AdminDashboardPage />,
  },
  {
    path: "/admin/referrals",
    element: <AdminReferralsPage />,
  },
  {
    path: "/admin/referrals/analytics",
    element: <AdminReferralAnalyticsPage />,
  },
  {
    path: "/admin/settings",
    element: <AdminSettingsPage />,
  },
  {
    path: "/admin/ledger-entry",
    element: <AdminLedgerEntryPage />,
  },
  {
    path: "/admin/promotions",
    element: <AdminPromotionsPage />,
  },
  {
    path: "/admin/sessions",
    element: <AdminSessionsPage />,
  },
  {
    path: "/admin/application-payments",
    element: <AdminApplicationPaymentsPage />,
  },
  {
    path: "/admin/online-billing",
    element: <AdminOnlineBillingPage />,
  },

  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
